// Mellymood – cambio de foto/precio/título en la tarjeta según el círculo de color.
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

function getCard(el) { return el.closest('product-card') || el.closest('.grid-view-item'); }

function original(card) {
  if (!card._mm) {
    const img = card.querySelector('img[data-product-card-image]');
    const price = card.querySelector('.product-grid--price');
    const title = card.querySelector('.product-grid--title a');
    card._mm = {
      src: img && img.getAttribute('src'),
      srcset: img && img.getAttribute('srcset'),
      price: price && price.innerHTML,
      title: title && title.textContent,
      links: [...card.querySelectorAll('a[data-product-card-link]')].map(a => [a, a.getAttribute('href')]),
    };
  }
  return card._mm;
}

function setActive(card, dot) {
  card.querySelectorAll('.mm-colors__dot').forEach(d => {
    d.classList.toggle('is-active', d === dot);
    d.toggleAttribute('aria-current', d === dot);
  });
}

function restore(card) {
  const o = card._mm;
  if (!o) return;
  const img = card.querySelector('img[data-product-card-image]');
  if (img && o.srcset) { img.setAttribute('srcset', o.srcset); img.setAttribute('src', o.src); }
  const price = card.querySelector('.product-grid--price');
  if (price && o.price != null) price.innerHTML = o.price;
  const title = card.querySelector('.product-grid--title a');
  if (title && o.title != null) title.textContent = o.title;
  o.links.forEach(([a, href]) => a.setAttribute('href', href));
  card.classList.remove('mm-swapped');
  setActive(card, card.querySelector('.mm-colors__dot.is-current'));
}

function show(card, dot) {
  if (dot.classList.contains('is-current')) { restore(card); return; }
  original(card);
  const img = card.querySelector('img[data-product-card-image]');
  if (img && dot.dataset.mmSrcset) {
    img.setAttribute('srcset', dot.dataset.mmSrcset);
    img.setAttribute('src', dot.dataset.mmSrc);
    img.removeAttribute('loading');
  }
  const price = card.querySelector('.product-grid--price');
  const tpl = dot.querySelector('template');
  if (price && tpl) price.innerHTML = tpl.innerHTML;
  const title = card.querySelector('.product-grid--title a');
  if (title && dot.dataset.mmTitle) title.textContent = dot.dataset.mmTitle;
  card._mm.links.forEach(([a]) => a.setAttribute('href', dot.getAttribute('href')));
  card.classList.add('mm-swapped');
  setActive(card, dot);
}

// Escritorio: hover cambia la tarjeta, al salir vuelve al original; el clic navega normal.
document.addEventListener('mouseover', e => {
  if (!canHover.matches) return;
  const dot = e.target.closest('.mm-colors__dot');
  if (!dot) return;
  const card = getCard(dot);
  if (card) show(card, dot);
});
document.addEventListener('mouseout', e => {
  if (!canHover.matches) return;
  const wrap = e.target.closest('[data-mm-colors]');
  if (!wrap || wrap.contains(e.relatedTarget)) return;
  const card = getCard(wrap);
  if (card) restore(card);
});

// Táctil: primer toque cambia la tarjeta; tocar el círculo ya seleccionado navega.
document.addEventListener('click', e => {
  const dot = e.target.closest('.mm-colors__dot');
  if (!dot) return;
  e.stopPropagation();
  if (canHover.matches) return; // escritorio: navega
  if (dot.classList.contains('is-active')) return; // segundo toque: navega
  e.preventDefault();
  const card = getCard(dot);
  if (card) show(card, dot);
}, true);

// Precarga la foto al acercarse el puntero, para que el cambio sea instantáneo.
document.addEventListener('pointerenter', e => {
  const wrap = e.target.closest && e.target.closest('[data-mm-colors]');
  if (!wrap || wrap._mmPreloaded) return;
  wrap._mmPreloaded = true;
  wrap.querySelectorAll('.mm-colors__dot[data-mm-src]').forEach(d => { const i = new Image(); i.src = d.dataset.mmSrc; });
}, true);
